import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../../routes/admin/admin-confirmation/admin-confirmation.component';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { IconsType } from '../../models/enum/icons.type';


@Component({
  selector: 'app-unauthorized-client',
  templateUrl: './unauthorized-client.component.html',
  styleUrls: ['./unauthorized-client.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UnauthorizedClientComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  public IconsType = IconsType;
  constructor(
    public dialogRef: MatDialogRef<UnauthorizedClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authService: AuthService,
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.authService.isLoggedIn.subscribe((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          this.dialogRef.close();
        }
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onClose(): void {
    this.dialogRef.close(1);
  }
}
